import React, {Component} from 'react';
import Card from 'react-bootstrap/Card';
import {Button, Form} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import {toast} from 'react-toastify';
import Table from 'react-bootstrap/Table';
const $ = require('jquery');
const jzip = require('jzip');
import ClockLoader from 'react-spinners/ClockLoader';
import Select from 'react-select';
window.JSZip = jzip;

const columns = [
  // {
  //   title: '#',
  //   data: 'costId'
  // },
  {
    title: 'บริษัท',
    data: 'companyName'
  },
  {
    title: 'Cost Center',
    data: 'costCenterName'
  },
  {
    title: 'เดือน',
    data: 'month'
  },
  {
    title: 'งบรายเดือน',
    data: 'costBudget'
  },
  {
    title: 'เบิกค่าเดินทาง',
    data: 'costCdsSpent'
  },
  {
    title: 'เบิกค่ารถบริการ',
    data: 'costCarserviceSpent'
  },
  {
    title: 'รวมเบิก',
    data: 'totalSpent'
  },
  {
    title: 'คงเหลือ',
    data: 'costRemain'
  },
  {
    title: 'จำนวนใบงาน/ตรวจ',
    data: 'requestCount',
    render: function (data, type, row) {
      if (type === 'display') {
        return row.status === 'approve'
          ? `<a class="col-12 btn btn-success btn-sm">${data} ใบงาน/ตรวจแล้ว</a>`
          : row.status === 'reject'
          ? `<a class="col-12 btn btn-danger btn-sm">${data} ใบงาน/ตรวจแล้ว</a>`
          : `<a class="col-12 btn btn-outline-primary btn-sm">${data} ใบงาน/กดตรวจ</a>`;
      }
      return data;
    }
  }
];

function reloadTableData(items, page) {
  console.log('reload: ' + items.length);
  console.log('page: ' + page);
  const table = $(`#${0}`).DataTable();
  table.clear();

  table.rows.add(items);
  table.draw();
  table.page(page).draw('page');

  setTimeout(function () {
    table.columns.adjust();
  }, 50);
}

function generate5years() {
  let currentYear = new Date().getFullYear(),
    years = [];
  for (let i = 0; i < 5; i++) {
    years.push({value: currentYear + 1, label: currentYear + 1});
    currentYear = currentYear - 1;
  }
  return years;
}

function hideCols(show) {
  console.log('hide');
  var column;
  column = $(`#${0}`).DataTable().column(8);
  column.visible(show);
}

class TableCostItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: null,
      companyid: null,
      costid: null,
      showMd: false
    };
  }

  componentDidMount() {
    var table = $(`#${0}`).DataTable({
      data: this.props.items,
      dom: 'Bfrtip',
      columns,
      searching: true,
      order: [[0, 'asc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      bDestroy: true,
      scrollX: true,
      scrollCollapse: true, // ถ้าตารางเล็กกว่า scroll container

      fixedColumns: {
        leftColumns: 1,
        rightColumns: 2
      },
      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        if (
          aData.month <=
          new Date(new Date().setMonth(new Date().getMonth() - 0))
            .toISOString()
            .slice(0, 7)
        ) {
          $('td', nRow).css('background-color', '#E0FFFF');
        } else {
          $('td', nRow).css('background-color', '');
        }
      },
      errMode: 'none',
      pageLength: 12,
      // responsive: true,
      // columnDefs: [{target: 6, visible: false}],
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_costcenter_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_costcenter_excel_${Date.now()}`
        }
      ]
    });
    $.fn.dataTable.ext.errMode = 'none';

    $(`#${0} tbody`).on('click', 'a', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      console.log(data);
      this.props.downloadCostCenterWs(
        'month',
        this.state.companyid,
        this.state.costid,
        data.month.replaceAll('-', '')
      );
      this.setState({showMd: true});
      // this.props.onToggle(data);
    });

    table.on('page', (event) => {
      var info = table.page.info();
      this.props.onPageChange(info.page);
    });
  }

  componentWillUnmount() {
    $(`#${0}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    console.log('HOHO');
    console.log(this.props.yearMonthSelect);

    // if (nextProps.items.length !== this.props.items.length) {
    if (nextProps.cr !== true && nextProps.ibc !== true) {
      //ซ้อน ถ้าไม่ใช่ cr และไม่ใช่ ibc
      hideCols(false);
    } else {
      //แสดง
      hideCols(true);
    }
    reloadTableData(nextProps.items, nextProps.page);
    // }
    return true;
  }

  render() {
    return (
      <div>
        <Modal
          show={this.state.showMd}
          className={'modal-fullscreen'}
          // size={'lg'}
          onHide={() => {
            this.props.setYearMonthSelect('222401');
            this.setState({showMd: false});
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{'รายงานการเบิกกลุ่มต้นทุน'}</Modal.Title>
          </Modal.Header>
          {/* <Modal.Body> */}
          <div
            // className="container"
            // style="overflow-y: scroll; height:400px;"
            style={{
              height: '80%',
              width: '100%',
              overflowY: 'scroll'
            }}
          >
            <Table striped>
              <thead>
                <tr>
                  <th className="d-none d-sm-table-cell">#</th>
                  <th className="d-none d-sm-table-cell">วันที่เดินทาง</th>
                  <th className="d-none d-sm-table-cell">ประเภท</th>
                  <th className="d-none d-lg-table-cell">วัตถุประสงค์</th>
                  <th className="d-none d-lg-table-cell">ค่าเดินทาง</th>
                  <th className="d-none d-lg-table-cell">รหัสพนักงาน</th>
                  <th className="d-none d-lg-table-cell">ชื่อพนักงาน</th>
                  <th>วันที่ขอเบิก</th>
                </tr>
              </thead>
              <tbody>
                {this.props.items2 ? (
                  this.props.items2.map((e, i) => {
                    return (
                      <tr key={`car-${i}`}>
                        <td>{e.planId}</td>
                        <td className="d-none d-sm-table-cell">{e.tripDate}</td>
                        <td className="d-none d-sm-table-cell">{e.carType}</td>
                        <td className="d-none d-sm-table-cell">
                          {e.objective}
                        </td>
                        <td>{e.costSpent}</td>
                        <td className="d-none d-sm-table-cell">{e.staffID}</td>
                        <td className="d-none d-lg-table-cell">
                          {e.staffName}
                        </td>
                        <td>{e.requestDateTime}</td>
                      </tr>
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </Table>
          </div>
          <div className="row">
            <Button
              className="col-12 m-2"
              variant="outline-danger"
              disabled={true}
            >
              คำแจ้งเตือน: การไม่เห็นชอบ จะมีผลให้ costcenter
              นี้ถูกระงับการใช้งานชั่วคราวในเดือนถัดไป, โปรดพิจารณาด้วยความระวัง
            </Button>
            <Button
              variant="success col-2"
              className="ml-2 mt-2 mb-2"
              onClick={this.props.export}
            >
              Excel
            </Button>
            <Button
              className={
                this.props.yearMonthSelect + '01' <=
                new Date(new Date().setMonth(new Date().getMonth() - 0))
                  .toISOString()
                  .slice(0, 10)
                  .replaceAll('-', '')
                  ? 'ml-2 mt-2 mb-2'
                  : 'd-none'
              }
              variant="primary col-2"
              disabled={this.props.status != ''}
              onClick={(e) => {
                this.props.approve();
                this.setState({showMd: false});
              }}
            >
              เห็นชอบ
            </Button>
            <Button
              className={
                this.props.yearMonthSelect + '01' <=
                new Date(new Date().setMonth(new Date().getMonth() - 0))
                  .toISOString()
                  .slice(0, 10)
                  .replaceAll('-', '')
                  ? 'ml-2 mt-2 mb-2'
                  : 'd-none'
              }
              variant="danger col-2"
              disabled={this.props.status != ''}
              onClick={(e) => {
                this.props.reject();
                this.setState({showMd: false});
              }}
            >
              ไม่เห็นชอบ
            </Button>
          </div>
          {/* </Modal.Body> */}
        </Modal>
        <Card className="card">
          <div className={this.props.loading ? 'overlay dark' : 'd-none'}>
            <ClockLoader color="#c4c4c4" />
          </div>
          <Card.Header>
            <div className="row">
              <Form.Check // prettier-ignore
                className="col-12 col-md-2 mb-1 mt-2"
                type={'checkbox'}
                id={`cb-me`}
                label={`เฉพาะฉัน(ibc)อนุมัติ`}
                onChange={(event) => {
                  const checked = event.target.checked;
                  this.props.downloadDropdownOnlyMe(checked);
                }}
              />
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({...base, zIndex: 9999}) // ให้สูงกว่า FixedColumns
                }}
                value={generate5years().filter(
                  (e) => e.value === this.state.year
                )}
                className="col-12 col-md-2 mb-1"
                placeholder={'เลือกปี'}
                options={generate5years()}
                onChange={(v) => {
                  this.setState({year: v.value});
                }}
              />
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({...base, zIndex: 9999}) // ให้สูงกว่า FixedColumns
                }}
                className="col-12 col-md-3 mb-1"
                value={this.props.dropdownCompany.DATA.filter(
                  (e) => e.value === this.state.companyid
                )}
                placeholder={'เลือกบริษัท'}
                options={this.props.dropdownCompany.DATA}
                onChange={(v) => {
                  this.setState({companyid: v.value});
                }}
              />
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({...base, zIndex: 9999}) // ให้สูงกว่า FixedColumns
                }}
                className="col-12 col-md-3 mb-1"
                value={this.props.dropdownCostcenter.DATA.filter(
                  (e) => e.value === this.state.costid
                )}
                placeholder={'เลือกกลุ่มต้นทุน'}
                options={
                  this.state.companyid === ''
                    ? this.props.dropdownCostcenter.DATA
                    : this.props.dropdownCostcenter.DATA.filter(
                        (e) => e.company === this.state.companyid
                      )
                }
                onChange={(v) => {
                  this.setState({costid: v.value});
                }}
              />
              <Button
                className="col-12 col-md-1 mb-1"
                variant="success"
                onClick={() => {
                  if (
                    this.state.companyid === null ||
                    this.state.costid === null ||
                    this.state.year === null
                  ) {
                    toast.error('เลือกปี/บริษัท/กลุ่มต้นทุนให้ครบ');
                  } else {
                    this.props.downloadCostCenterWs(
                      'year',
                      this.state.companyid,
                      this.state.costid,
                      this.state.year
                    );
                  }
                }}
              >
                ค้นหา
              </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <table
              ref="main"
              className="display nowrap example"
              id={0}
              style={{width: '100%'}}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
export default TableCostItem;
